import React from 'react';
import { Col, Card, CardBody } from 'reactstrap';

const stats = [
  {
    title: 'Total Return Request',
    value: '14k',
    sub: 'No. of Request',
    subValue: 26,
  },
  {
    title: 'Total Approved Return Request',
    value: '12k',
    sub: 'No. of Request',
    subValue: 19,
  },
  {
    title: 'Total Rejected Return Request',
    value: '02k',
    sub: 'No. of Request',
    subValue: 7,
  },
];

const ReturnStatsCards = () => (
  <>
    {stats.map((stat, idx) => (
      <Col xl={3} md={6} key={idx}>
        <Card>
          <CardBody>
            <h6 className="text-muted fw-normal">{stat.title}</h6>
            <div className="d-flex align-items-center">
              <h2 className="mb-0">{stat.value}</h2>
              <div
                className="ms-auto border d-flex justify-content-center align-items-center border-info rounded-circle"
                style={{ width: 30, height: 30 }}
              >
                <i className="bx bx-refresh font-size-24 text-info"></i>
              </div>
            </div>
            <p className="mb-0 text-muted">
              {stat.sub}:{' '}
              <span className="fw-bold text-success">{stat.subValue}</span>
            </p>
          </CardBody>
        </Card>
      </Col>
    ))}
  </>
);

export default ReturnStatsCards;
